import { createSelector } from 'reselect';
import { getSpacesPoints } from './getSpacesPoints';

const activeId = (store) => store.Map.activeId;

export const getActiveMarker = createSelector(
	getSpacesPoints,
	activeId,
	(points, id) => {
		if (!id) return null;
		const activePoint = points.find((p) => p.id.includes(id));

		if (!activePoint) return null;

		activePoint.coordinate = activePoint.spaces[0].coordinate;

		activePoint.spaces.sort((a, b) => {
			return id.indexOf(`${b.id}`) - id.indexOf(`${a.id}`);
		});
		activePoint.spaces.sort((a, b) => {
			if (!a.isLiked && b.isLiked) {
				return 1;
			}
			if (a.isLiked && !b.isLiked) {
				return -1;
			}
			return 0;
		});

		return activePoint;
	},
);
